export const style =
    <>
        <style>
            {`
                .collection {
                    gap: 10px;
                }
            `}
        </style>
    </>